import PropTypes from 'prop-types';

const SingleChoiceOption = () => null;

SingleChoiceOption.propTypes = {
  children: PropTypes.any,
  optionKey: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

SingleChoiceOption.defaultProps = {
  children: null,
  disabled: false,
  className: null,
};

export default SingleChoiceOption;
